import type { StateOption } from "../types/portal";

export const TRAINING_PHILOSOPHY_OPTIONS: string[] = [
  "Force Free / Pure Positive",
  "Positive Reinforcement Based (+R)",
  "Clicker / Marker Training",
  "Fear Free",
  "Science Based",
  "Relationship Based",
  "Balanced",
  "LIMA (Least Intrusive, Minimally Aversive)",
  "Traditional Training Methods",
  "Alpha / Pack Based",
  "Remote Training",
];

export const AREAS_OF_EXPERTISE_OPTIONS: string[] = [
  "Puppy",
  "Manners",
  "Behavior Modification",
  "Aggression Management \u2013 Dog to dog",
  "Aggression Management - human directed",
  "Reactivity",
  "Separation Anxiety",
  "Anxiety / Fears / Phobias",
  "Leash Walking",
  "Potty Training",
  "Rescue Rehab",
  "Service Dog",
  "Therapy Dog",
  "Protection",
  "Tracking",
  "Competition Obedience",
  "Scentwork",
  "Agility",
  "Conformation",
  "Herding",
  "Earthdog",
];

export const CREDENTIAL_OPTIONS: string[] = [
  "Formal degree",
  "Professional Dog Trainer School",
  "International Association of Canine Professionals",
  "Prong Collar Assessment",
  "CDT",
  "CDTA",
  "Certification Council of Canine Dog Trainers",
  "CPDT-KA",
  "CPDT-KSA",
  "CBCC-KA",
  "CBCC-KSA",
  "NADOI \u2013 Certified Member",
  "Puppy",
  "Novice Competition",
  "Open Competition",
  "Utility Competition",
  "Tracking",
  "Tracking Excellent",
  "Agility",
  "Agility Excellent",
  "Karen Prior Academy",
  "CDT",
  "Association of Animal Behavior Professionals",
  "CDBT",
  "Certified Fear Free",
  "Stephan Lynsay LIMA",
  "Grisha Stewart CBATI",
  "AKC Judge",
  "Fetch",
  "Farm Dog",
  "Obedience",
  "Rally",
  "Scentwork",
  "Herding",
  "Agility",
  "AKC Canine Good Citizen Evaluator",
  "Canine Fitness Instructor",
  "CCFT \u2013 list affiliation",
  "Do More With Your Dogs",
  "CRDI",
  "CCFC",
  "SDJ",
  "AACE",
  "Other sport judge",
  "Breed expert",
];

export const LANGUAGE_OPTIONS: string[] = [
  "English",
  "Spanish",
  "French",
  "German",
  "Italian",
  "Portuguese",
  "Mandarin",
  "Cantonese",
  "Japanese",
  "Korean",
  "Vietnamese",
  "Tagalog",
  "Hindi",
  "Punjabi",
  "Urdu",
  "Arabic",
  "Russian",
  "Polish",
  "Dutch",
  "Greek",
  "Turkish",
  "Hebrew",
  "American Sign Language (ASL)",
];

export const TIME_ZONE_OPTIONS: string[] = [
  "Pacific Time",
  "Mountain Time",
  "Central Time",
  "Eastern Time",
  "Alaska Time (AKT)",
  "Hawaii Time (HST)",
];

export const US_STATE_OPTIONS: StateOption[] = [
  { value: "AL", label: "Alabama" },
  { value: "AK", label: "Alaska" },
  { value: "AZ", label: "Arizona" },
  { value: "AR", label: "Arkansas" },
  { value: "CA", label: "California" },
  { value: "CO", label: "Colorado" },
  { value: "CT", label: "Connecticut" },
  { value: "DE", label: "Delaware" },
  { value: "FL", label: "Florida" },
  { value: "GA", label: "Georgia" },
  { value: "HI", label: "Hawaii" },
  { value: "ID", label: "Idaho" },
  { value: "IL", label: "Illinois" },
  { value: "IN", label: "Indiana" },
  { value: "IA", label: "Iowa" },
  { value: "KS", label: "Kansas" },
  { value: "KY", label: "Kentucky" },
  { value: "LA", label: "Louisiana" },
  { value: "ME", label: "Maine" },
  { value: "MD", label: "Maryland" },
  { value: "MA", label: "Massachusetts" },
  { value: "MI", label: "Michigan" },
  { value: "MN", label: "Minnesota" },
  { value: "MS", label: "Mississippi" },
  { value: "MO", label: "Missouri" },
  { value: "MT", label: "Montana" },
  { value: "NE", label: "Nebraska" },
  { value: "NV", label: "Nevada" },
  { value: "NH", label: "New Hampshire" },
  { value: "NJ", label: "New Jersey" },
  { value: "NM", label: "New Mexico" },
  { value: "NY", label: "New York" },
  { value: "NC", label: "North Carolina" },
  { value: "ND", label: "North Dakota" },
  { value: "OH", label: "Ohio" },
  { value: "OK", label: "Oklahoma" },
  { value: "OR", label: "Oregon" },
  { value: "PA", label: "Pennsylvania" },
  { value: "RI", label: "Rhode Island" },
  { value: "SC", label: "South Carolina" },
  { value: "SD", label: "South Dakota" },
  { value: "TN", label: "Tennessee" },
  { value: "TX", label: "Texas" },
  { value: "UT", label: "Utah" },
  { value: "VT", label: "Vermont" },
  { value: "VA", label: "Virginia" },
  { value: "WA", label: "Washington" },
  { value: "WV", label: "West Virginia" },
  { value: "WI", label: "Wisconsin" },
  { value: "WY", label: "Wyoming" },
];
